import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import UndoRounded from '@mui/icons-material/UndoRounded';
import { Button, Stack, Typography } from '@mui/material';
import { useAtom } from 'jotai';
import PropTypes from 'prop-types';

import { actionKPISelector } from 'src/components/planAction/PlanActionDetailPage/components/Action/atoms';
import { useTouchActionPlan } from 'src/components/planAction/PlanActionDetailPage/components/Action/hooks';

import KPIGrid from './components/KPIGrid';
import KPIHistory from './components/KPIHistory';
import TargetStatementResults from './components/TargetStatementResults';

const KPISelector = ({ actionId, editable = false, errors = null }) => {
  const { t } = useTranslation('planAction');
  const [kpi, setKpi] = useAtom(actionKPISelector(actionId));

  const { touchActionPlan } = useTouchActionPlan();

  const handleSelectKpi = useCallback(
    (value) => {
      setKpi(value);
      touchActionPlan();
    },
    [setKpi, touchActionPlan],
  );

  return (
    <div>
      <Stack
        direction="row"
        sx={{ justifyContent: 'space-between', alignItems: 'center', py: 1 }}
      >
        {kpi === null ? (
          <Typography variant="h6">
            {`${t('ActionPlan.SelectKPI')}*`}
          </Typography>
        ) : (
          <div />
        )}
        {editable && kpi !== null && (
          <div>
            <Button
              variant="cta"
              color="tertiary"
              startIcon={<UndoRounded />}
              onClick={() => setKpi(null)}
            >
              {t('ActionPlan.ChangeKPI')}
            </Button>
          </div>
        )}
      </Stack>
      {kpi ? (
        <>
          <KPIHistory kpi={kpi} />
          <TargetStatementResults kpi={kpi} actionId={actionId} />
        </>
      ) : (
        <KPIGrid
          onSelect={handleSelectKpi}
          editable={editable}
          errors={errors}
        />
      )}
    </div>
  );
};

KPISelector.propTypes = {
  actionId: PropTypes.number.isRequired,
  editable: PropTypes.bool,
  errors: PropTypes.shape({
    kpi: PropTypes.string,
  }),
};

export default KPISelector;
